import { useContext } from 'react';
import { useStyletron } from 'baseui';
import { TAG_COLORS_HEX, TAG_COLORS_RGBA } from '@gtintel/platform-constants';
import { ProjectContext } from '../../ProjectApp/context';
export const ProjectTags = () => {
  const {
    tags
  } = useContext(ProjectContext);
  const [css] = useStyletron();
  return <section className={css({
    margin: '18px 0'
  })} data-testid="project-tags">
      <div className={css({
      display: 'flex',
      flexFlow: 'row wrap',
      gap: '16px'
    })}>
        {tags().map(tag => {
        return <p className={css({
          background: `rgba(${TAG_COLORS_RGBA[Number(tag.tag_group)]}, .1)`,
          color: TAG_COLORS_HEX[Number(tag.tag_group)],
          borderRadius: '4px',
          padding: '4px 8px'
        })}>
              {tag.name}
            </p>;
      })}
      </div>
    </section>;
};